import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@material-ui/core';

function SubscriptionWizard({ steps, onLastNext, onChange, activeStep }) {
  const downSm = useMediaQuery(({ breakpoints }) => breakpoints.down('sm'));

  const step = steps[activeStep];
  const totalSteps = steps.length;
  const isLastStep = activeStep === totalSteps - 1;

  const onNext = () => {
    if (isLastStep) {
      return onLastNext();
    }

    onChange(Math.min(activeStep + 1, totalSteps - 1));
  };

  useEffect(() => {
    if (downSm) {
      window.scrollTo(0, 0);
    }
  }, [activeStep]);

  const onPrev = () => {
    onChange(Math.max(activeStep - 1, 0));
  };

  return (
    step.render &&
    step.render({
      activeStep,
      totalSteps,
      isLastStep,
      onNext,
      onPrev,
    })
  );
}

SubscriptionWizard.propTypes = {
  activeStep: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onLastNext: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      render: PropTypes.func,
    }),
  ),
};

export default SubscriptionWizard;
